import styled, { css } from 'styled-components';
import { MenuButton } from '../Menu';
export const StyledMenuButton = styled(MenuButton)(({
  $additionalStyles,
  theme
}) => {
  return css(["border-radius:50%;width:32px;height:32px;border:1px solid ", ";align-self:center;justify-self:center;align-content:center;justify-content:center;display:flex;background:transparent;flex-wrap:wrap;&:hover{background:", ";border:1px solid ", ";}& > svg{display:flex;fill:", ";}", ""], theme.color['global-shell-border-default'], theme.color['global-shell-fill-nav-item-hover'], theme.color['global-shell-border-dark'], theme.color['global-shell-icon-nav-item-default'], $additionalStyles);
});
StyledMenuButton.displayName = 'StyledMenuButton';